import qs from 'qs';

const defaultStoreReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_DEFAULT_STORE_CONFIRMING':
      return {
        ...state, state: 'confirming', idToSet: payload.storeId
      };
    case 'SET_DEFAULT_STORE_PENDING':
      return {
        ...state, state: 'pending', idToSet: payload.storeId
      };
    case 'SET_DEFAULT_STORE_CONFIRM_CANCELLED':
    case 'SET_DEFAULT_STORE_FULFILLED':
    case 'SET_DEFAULT_STORE_REJECTED':
      return { ...state, state: 'idle', idToSet: null };
    default:
      return state;
  }
}

export default function reducer(state = {
  performances: [],
  stores: [],
  missingProductIds: [],
  activeGame: {},
  paging: {
      number: 1,
      size: 20,
  },
  vouchers: [],
  fetching: false,
  fetched: false,
  errors: {},
  defaultStore: {
    state: 'idle',
    idToSet: null
  }
}, action) {
  if (/^SET_DEFAULT_STORE_/.test(action.type)) {
    return {
      ...state,
      defaultStore: defaultStoreReducer(state.defaultStore, action)
    };
  }

  switch (action.type) {
    case 'GET_STORE_PERFORMANCE_DATA_PENDING':
    case 'GET_OUTLETS_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_MISSING_PRODUCTS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        missingProductIds: action.payLoad
      }
    }
    case 'GET_ACTIVE_GAME_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        activeGame: action.payLoad
      }
    }
    case 'GET_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stores: action.payLoad.data
      }
    }
    case 'GET_ADMIN_OUTLETS_FULFILLED': {
        const lastPage = action.payLoad.links.last;
        let page = state.paging;
        if (lastPage) {
            page = qs.parse(lastPage.split('?')[1]).page;
        } else if (Object.keys(action.payLoad.links).length === 0) {
            page = {
                number: 1,
                size: 20,
            };
        }
        return {
            ...state,
            fetching: false,
            fetched: true,
            stores: action.payLoad.data,
            links: action.payLoad.links,
            paging: page
        }
    }
    case 'GET_OUTLET_VOUCHERS_FULFILLED': {
      return {
        ...state,
        vouchers: action.payLoad,
      }
    }
    case 'GET_OUTLETS_REJECTED': {
      return {
        ...state, errors: action.payLoad
      }
    }
    case 'GET_STORE_PERFORMANCE_DATA_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        performances: action.payLoad,
      }
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/storeReducer.js